import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { profileApi, queryClient } from '~/lib/request';

export function useRemoveAvatar() {
  return useMutation<unknown, Error, void>({
    mutationFn: async () => {
      await profileApi.delete('api/profile/me/avatar');
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['currentUser'] });
      toast.success('Avatar removed successfully!');
    },
    onError: () => {
      toast.error('Failed to remove avatar');
    },
  });
}
